import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { tienePermisoEnSesion } from "@/shared/auth/permiso-en-sesion";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { CalendarioPagosPage } from "@/features/calendario-pagos/components/CalendarioPagosPage";
import { CalendarioPagosPaginaSkeleton } from "@/features/calendario-pagos/components/CalendarioPagosSkeleton";
import { calendarioPagosQueryOptions } from "@/features/calendario-pagos/hooks/use-calendario-pagos";
import { mesInicial, paramsCalendario } from "@/features/calendario-pagos/utils/params-calendario";

/**
 * Ruta `/calendario-pagos` (P39) · calendario de pagos programados,
 * exclusivo de Mesa de Control (el servidor re-valida siempre). Loader
 * precarga el mes en curso con los MISMOS params que arma la página al montar.
 */
export const Route = createFileRoute("/_authed-tw/calendario-pagos")({
  loader: ({ context: { queryClient } }) =>
    tienePermisoEnSesion([PERMISOS.calendarioPagosVer])
      ? queryClient.ensureQueryData(calendarioPagosQueryOptions(paramsCalendario(mesInicial())))
      : undefined,
  // Mientras resuelve la precarga · la MISMA forma que la página (no el PageSkeleton genérico).
  pendingComponent: CalendarioPagosPaginaSkeleton,
  component: () => (
    <PermissionGate permisos={[PERMISOS.calendarioPagosVer]}>
      <CalendarioPagosPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
